<div class="page-bounds">
    <div class="all-header">
        <div
            #selectorAnchor
            class="card medium-padding-right medium-padding-left no-print"
            [class.with-selector-open]="isClassificationNodeSelectorOpen"
            [class.simplified-header]="simplifiedHeader"
        >
            @if (!simplifiedHeader) {
                <div class="left-header">
                    <div
                        class="p-3 flex-column gap-1 text bg-light-highlight-hover rounded cursor-hand"
                        [tabindex]="0"
                        (click)="openNodeSelector()"
                        (keydown.enter)="openNodeSelector()"
                    >
                        <div class="text-body-bold flex-row gap-2">
                            <span>{{ 'COMPONENTS.MAIN_HEADER.SELECT_A_SCOPE' | translate }}</span>
                            <ui-icon-button
                                size="small"
                                boundaries="icon"
                                [iconName]="isClassificationNodeSelectorOpen ? 'retract' : 'expand'"
                            />
                        </div>
                        <div class="text-body">
                            @if (classificationNodeId$ | async; as nodeId) {
                                <span>
                                    {{ nodeId | classificationNodeName }}
                                </span>
                            }
                            &nbsp;
                        </div>
                    </div>
                </div>
            }
            <div class="right-header">
                @if (isAuthenticated$ | async) {
                    <project-select />
                }
                <div class="advizeo-toolbar">
                    @if (currentUser$ | async) {
                        <ui-icon-button iconName="create" (click)="openMoreMenu($event)" />
                    }
                    @if ((currentUser$ | async) && canAccessFeature(ACCESS_PROJECT_ADMINISTRATION)) {
                        <ui-icon-button iconName="admin" (click)="openAdminMenu($event)" />
                    }
                </div>
                <div class="identity" [tabindex]="0" (click)="openUserMenu($event)" (keydown.enter)="openUserMenu($event)">
                    @if (currentUser$ | async) {
                        <img class="profile-icon cursor-hand" alt="user image" cy-profile-picture [src]="profilePicture$ | async" />
                    }
                </div>
            </div>
        </div>
        <div class="report-header">
            <div class="report-title">
                @if (reportType$ | async) {
                    <div class="title">
                        {{ 'PRINT.REPORT' | translate | uppercase }}
                        {{ reportType$ | async }}
                    </div>
                }
                <div class="subtitle">
                    <div>
                        {{ 'PRINT.PERIOD' | translate }}
                        {{ (selectedPeriod$ | async)?.name | translatePeriod }}
                    </div>
                    <div>
                        {{ 'PRINT.PERIMETER' | translate }}
                        {{ classificationNodeId$ | async | classificationNodeName }}
                    </div>
                    <div>
                        {{ 'PRINT.GENERATED_ON' | translate }}
                        {{ currentDate | plainDate }}
                    </div>
                </div>
            </div>
            @if (project$ | async; as project) {
                @if (project.bigPictureUrl || project.logoUrl) {
                    <img alt="logo" [src]="project.bigPictureUrl || project.logoUrl" />
                }
            }
        </div>
    </div>
</div>
